export default __webpack_public_path__ + "c8fc802853ecf28dcefa8430f0e608cf.png";